export default __webpack_public_path__ + "static/media/argosBackground.bf85972c.png";